import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { SessionTimeoutModal } from '@hsp/react-component-library';
import { useIdle } from '@hsp/react-hooks';

import { customEvents } from 'constants/custom-events';
import { defaultSessionTime } from 'constants/session';
import { useExtendToken } from 'hooks/token';
import { publishCustomEvent } from 'utilities/events';
import { buildUrl } from 'utilities/strings';

const Idle = () => {
  const extendToken = useExtendToken();
  const { logoff, onContinue, prompt, remaining } = useIdle({
    onExtendToken: extendToken,
    onLogoff: () => publishCustomEvent(customEvents.logOffEvent),
    promptTime: defaultSessionTime * 0.25,
    sessionLength: defaultSessionTime,
  });
  const navigate = useNavigate();
  const handleLogout = useCallback(() => {
    navigate(buildUrl('Root.children.Logout'), { replace: true });
  }, [navigate]);

  useEffect(() => {
    if (logoff) {
      handleLogout();
    }
  }, [handleLogout, logoff]);

  return prompt ? (
    <SessionTimeoutModal
      onContinue={onContinue}
      onLogout={handleLogout}
      remaining={remaining}
      show={prompt}
    />
  ) : null;
};

export default Idle;
